var render = function render2() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", _vm._g({ staticClass: "flex-grow flex justify-center", class: {
    "modal": !_vm.white,
    "whiteModal": _vm.white,
    "items-center px-8": !_vm.full && ["md", "de", "lg"].includes(_vm.$mq),
    "items-center p-4": !_vm.full && _vm.$mq === "sm",
    "max-h-full": _vm.full && _vm.$mq === "sm"
  } }, _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
